<template>
  <AppModal
    :useDimness="true"
    @close="closeModal"
  >
    <template slot="modal-header">
      <h3 class="font-weight-medium">Add Term</h3>
    </template>
    <template slot="modal-body">
      <TermForm
        v-model="term"
        :editable="editable"
        :fields="termFields"
        @validation="handleValidation"
      />
    </template>
    <template slot="modal-footer">
      <AppButton
        variant="secondary"
        class="mr-auto"
        data-test="cancelNewTermBtn"
        @click="closeModal"
      >
        Cancel
      </AppButton>
      <AppTooltip :disabled="!termCombinedValidations.$invalid">
        <AppButtonWithLoader
          raised
          :loading="isCreatingTerm"
          :disabled="isCreatingTerm || termCombinedValidations.$invalid"
          data-test="addNewTermBtn"
          @click="createTerm"
        >
          Add New Term
        </AppButtonWithLoader>
        <template #tooltip>
          <p class="mb-0">Please fill out all required fields before submitting</p>
        </template>
      </AppTooltip>
    </template>
  </AppModal>
</template>

<script>
import { mapGetters } from 'vuex'
import TermForm from '@sm/client/components/Terms/TermForm'
import { combineValidations } from '@/utils/vuelidate'

export default {
  components: {
    TermForm,
  },
  data: () => ({
    term: {},
    termValidations: {},
    isCreatingTerm: false,
  }),
  computed: {
    ...mapGetters([ 'terms' ]),
    termFields () {
      return [
        {
          name: 'semester',
          required: true,
        },
        {
          name: 'year',
          required: true,
        },
      ]
    },
    editable () {
      const routeName = this.$route.name
      if (routeName === 'smTermSettings') return this.$hasAccess().to('institutionSettings').to('editTerms').value()
      else return this.$hasAccess().to('emSettings').to('editTerms').value()
    },
    // There are a few SchemaForms in TermForm, each of them send a whole validation object,
    // so we have to combine them, as storing just `$invalid` Boolean will be overwriten by each of them.
    termCombinedValidations () {
      return combineValidations(Object.values(this.termValidations).map(({ $v }) => $v))
    },
  },
  methods: {
    async createTerm () {
      try {
        this.isCreatingTerm = true
        await this.$store.dispatch('createTerm', { term: this.term })
        this.closeModal()
        this.$store.dispatch('ui/showSnackbar', { text: 'Term Successfully Created' })
      } catch (err) {
        console.error(err)
        this.$store.dispatch('ui/showSnackbar', { text: 'Something went wrong...', variant: 'danger' })
      } finally {
        this.isCreatingTerm = false
      }
    },
    handleValidation ($v, formId) {
      if (!Object.keys($v || {}).length) {
        const { [formId]: toRemove, ...rest } = this.termValidations
        this.termValidations = rest
      } else {
        this.termValidations = { ...this.termValidations, [formId]: { $v } }
      }
    },
    closeModal () {
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
.modal-backdrop >>> .modal-body {
  overflow: auto;
}
</style>
